"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEmptyMessage = void 0;
const react_1 = __importDefault(require("react"));
// Components
const TableHeader_1 = __importDefault(require("./TableHeader"));
const TableRow_1 = __importDefault(require("./TableRow"));
const Table_1 = require("./Table");
const Theme_1 = require("../../Theme/Theme");
exports.StyledEmptyMessage = Theme_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  font-family: proxima-nova, sans-serif;
  color: ${(props) => props.theme.colors.gray[70]};
  border: 1px solid ${(props) => props.theme.colors.gray[30]};
  border-top: none;
  height: 51px;
  background-color: ${(props) => props.theme.white};
`;
const SmrStaticTable = (props) => {
    const { columns, rows, emptyMessage } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Table_1.StyledTableContainer, null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement(TableHeader_1.default, { isStatic: true, columns: columns })),
            react_1.default.createElement("tbody", null, rows.length > 0 &&
                rows.map((row, i) => (react_1.default.createElement(TableRow_1.default, { key: `static_table_row_${i}_${JSON.stringify(row.cells.map((cell) => cell.value))}`, columns: columns, height: row.height, cells: row.cells }))))),
        rows.length === 0 && (react_1.default.createElement(exports.StyledEmptyMessage, null, emptyMessage || 'No data'))));
};
exports.default = SmrStaticTable;
//# sourceMappingURL=StaticTable.js.map